import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { PostForm } from './../forms'
import { Dashboard } from './../layouts'
import axios from './../plugins/axios'

const styles = theme => ({
    //
})

class PostUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Мэдээ',
            key: shortid.generate(),
            name: '',
            images: [],
            body: ''
        }
    }

    componentDidMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/posts/${id}`)

            this.setState({
                key: shortid.generate(),
                name: data.title,
                images: data.images,
                body: data.body
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            title,
            key,
            name,
            images,
            body
        } = this.state
        const { match } = this.props
        const { id } = match.params
        return (
            <Dashboard title={title}>
                <PostForm
                    key={key}
                    path={`posts/${id}`}
                    method="put"
                    title={name}
                    images={images}
                    body={body}
                    message="Амжилттай шинэчлэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(PostUpdate)
